module.exports = __webpack_public_path__ + "p6_img5.jpg?98dd45ed78a27a489ae01dd014aef4da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img5.jpg
// module id = 125
// module chunks = 0